module.exports = __webpack_public_path__ + "static/media/banner-new.f9770b32.png";